enum EStatusViagemPedagio {
  QUITADO = 'QUITADO',
  EM_ABERTO = 'EM_ABERTO',
  CANCELADO = 'CANCELADO',
  EM_TRANSITO = 'EM_TRANSITO',
  NAO_INFORMADO = 'NAO_INFORMADO',
}

export default EStatusViagemPedagio

export const StatusViagemPedagio: {
  [key in EStatusViagemPedagio]: string
} = {
  [EStatusViagemPedagio.QUITADO]: 'Viagem quitada',
  [EStatusViagemPedagio.EM_ABERTO]: 'Viagem em Aberto',
  [EStatusViagemPedagio.CANCELADO]: 'Viagem cancelada',
  [EStatusViagemPedagio.EM_TRANSITO]: 'Viagem em trânsito',
  [EStatusViagemPedagio.NAO_INFORMADO]: 'Não informado',
}

export const getStatusViagemPedagio = (
  status: string,
): EStatusViagemPedagio => {
  switch (status) {
    case 'QUITADO':
      return EStatusViagemPedagio.QUITADO
    case 'EM_ABERTO':
      return EStatusViagemPedagio.EM_ABERTO
    case 'CANCELADO':
      return EStatusViagemPedagio.CANCELADO
    case 'EM_TRANSITO':
      return EStatusViagemPedagio.EM_TRANSITO
    default:
      return EStatusViagemPedagio.NAO_INFORMADO
  }
}

export function isStatusHabilitaVerDetalhes(status: string): boolean {
  const statusEnum = getStatusViagemPedagio(status)
  return !(
    statusEnum === EStatusViagemPedagio.EM_TRANSITO ||
    statusEnum === EStatusViagemPedagio.CANCELADO ||
    statusEnum === EStatusViagemPedagio.NAO_INFORMADO
  )
}

export function getStatusViagemPedagioFormatado(status: string): string {
  return StatusViagemPedagio[getStatusViagemPedagio(status)]
}
